import b from 'b_';
import cx from 'classnames';
import React from 'react';

import { CertificateBannerContent } from './__content/certificate-banner__content';
import { CertificateBannerImage } from './__image/certificate-banner__image';
import { Props } from './types';

import './certificate-banner.scss';

export const CertificateBanner = (React.memo as <C>(c: C) => C)(function CertificateBannerImpl<
    B extends boolean | JSX.Element = true,
>({
    headerText,
    description,
    buttonText,
    imageSrc,
    imageStyle,
    layout,
    showButton = true as B,
    mix,
    onClick,
    buttonProps,
    theme = 'default',
}: Props<B>) {
    return (
        <div className={cx(b('certificate-banner', { layout, theme }), mix)}>
            <CertificateBannerContent
                buttonProps={buttonProps}
                buttonText={buttonText}
                description={description}
                headerText={headerText}
                layout={layout}
                onClick={onClick}
                showButton={showButton as any}
            />
            <CertificateBannerImage layout={layout} src={imageSrc} style={imageStyle} />
        </div>
    );
});

export { CERTIFICATE_LAYOUT } from './types';
